<template>
  <div :class="{'hidden':hidden}" class="pagination-container">
    <el-pagination
      :background="background"
      :current-page.sync="currentPage"
      :page-size.sync="pageSize"
      :layout="layout"
      :total="total"
      v-bind="$attrs"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
import { scrollTo } from '@/components/basicComponents/scrollTo.js'
export default {
  name: 'Pagination',
  props: {
    total: {
      required: true,
      type: Number
    },
    page: {
      type: Number,
      default: 1
    },
    page_size: {
      type: Number,
      default: 10
    },
    pageSizes: {
      type: Array,
      default () {
        return [10, 20, 30, 50]
      }
    },
    layout: {
      type: String,
      default: 'total, prev, pager, next'
    },
    background: {
      type: Boolean,
      default: true
    },
    autoScroll: {
      type: Boolean,
      default: true
    },
    hidden: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    currentPage: {
      get () {
        return this.page
      },
      set (val) {
        this.$emit('update:page', val)
      }
    },
    pageSize: {
      get () {
        return this.page_size
      },
      set (val) {
        this.$emit('update:page_size', val)
      }
    }
  },
  methods: {
    handleSizeChange (val) {
      this.$emit('pagination', { page: this.currentPage, page_size: val })
      if (this.autoScroll) {
        scrollTo(0, 800)
      }
    },
    handleCurrentChange (val) {
      this.$emit('pagination', { page: val, page_size: this.pageSize })
      if (this.autoScroll) {
        scrollTo(0, 800)
      }
    }
  }
}
</script>

<style lang="less">
// .pagination-container {
//   width:100%;
//   text-align: right;
//   background: #fff;
//   padding: 20px 0 60px 16px;
// }
// .pagination-container.hidden {
//   display: none;
// }

// .pagination-container{
//   margin-top: 0px !important;
//   color: #0A2549 !important;
// .el-pager li:not(.disabled).active {
//     background-color:#4989CC !important;
//     color: #fff !important;
//     font-weight: 700
// }

// .el-pagination {
//     font-weight:normal !important;
// }
// .el-pager li {
//     margin: 0 5px;
//     background-color: #F0F0F0 !important;
//     color: #0A2549!important ;
//     min-width: 30px;
//     border-radius: 2px;
// }
// .el-pagination .btn-next .el-icon:hover, .el-pagination .btn-prev .el-icon:hover{
//   color: #0A2549;
// }
// .el-pagination .btn-next .el-icon, .el-pagination .btn-prev .el-icon {
//     display: block;
//     font-size: 12px;
//     /* font-weight: 700; */
// }
// .el-pagination__total {
//      position: relative;
//      right: 7%;
//      color: #0A2549;
//     /* font-weight: 600; */
// }
// .el-input__inner{
//    color: #0A2549;
//     /* font-weight: 600; */

// }
// .el-pagination__jump{
//    color: #0A2549;
//    padding-right: 2%;
//    margin-left: 10px;
//     /* font-weight: 600; */
// }
//  .el-input__inner{
//       border: 1px solid #0A2549;
// }
//  .el-select .el-input.is-focus .el-input__inner {
//      border-color:  #0A2549;
//  }
// .el-select .el-input .el-select__caret{
//   color: #0A2549
// }
// }
// .el-pagination button, .el-pagination span:not([class*=suffix]){
// margin-left: 20px;
//   font-size: 12px;
// }
// .el-pagination .el-input__inner{
//   width: 70px;
//   height: 23px;
// }
// .el-scrollbar__view .el-select-dropdown__list{
//   width: 70px;
// }
// .el-select-dropdown__item.selected{
//   color:#fff !important;
//   background-color:#4989CC ;
//   padding-left: 20%;
//   height: 20px;
//   line-height: 20px;
//   font-size: 12px;
// }
// .el-select-dropdown__list{
//   width: 70px;
//   position: relative !important;
//   right: 0;
// }
// .el-select-dropdown__item{
//   padding-left: 20%;
//   color:#0A2549 !important;
//   font-size: 700;

// }
// .el-pagination .el-select .el-input{
//   right: 50px;
// }
// .pagination-container .el-pagination .btn-next .el-icon, .pagination-container .el-pagination .btn-prev .el-icon{
//   font-size: 16px;
// }
// .el-pagination .is-background .el-pager li:not(.disabled).active{
//   width: 22px;
//   height: 22px;
//   line-height: 22px;
//   background-color: #4989CC;
// }
// .el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li{
//   width: 22px;
//   height: 22px;
//   line-height: 22px;
//   position: relative;
//   top: -8px;
// }
// .el-pagination__editor.el-input .el-input__inner{
//   font-size: 10px;
//   width: 35px;
//   height: 22px;
//   margin-left: 6px;
//   margin-right: 6px;
// }
// .el-input{
//   display: inline;
// }
// .pagination-container .el-input__inner{
//   display: inline-block;
//   margin-top: -15px;
// }
// .el-select{
//   display: inline-block;
// }
// .el-input .el-input--mini .el-input--suffix{
//   position: absolute;
//   right: 100px;
// }
// .el-pagination .el-input__suffix{
//   right: 25px;
//   top: -13px;
// }
// .el-pagination .el-select .el-input .el-input__inner{
//   border: 1px solid #000 !important;
//   width: 70px;
//   height: 22px;
//   position: relative;
//   top:-12px;
//   right: 10px;
// }
// .el-pagination .el-popper[x-placement^=bottom] {
//     margin-top: 0px;
// }
</style>



// WEBPACK FOOTER //
// src/components/basicComponents/Pagination.vue